$(function () {

  $('input[data-toggle="notifications-toggle-reg"]').change(function () {
    const parent = $(this).parent().parent();
    const $email_notifications_checkbox = parent.find('input.email-notifications-enabled');
    const $sms_notifications_checkbox = parent.find('input.sms-notifications-enabled');
    const $phone_number_field_container = parent.find('.phone_number');

    $email_notifications_checkbox.prop('checked', this.checked);
    if (!this.checked) {
      $sms_notifications_checkbox.prop('checked', false);
      $phone_number_field_container.fadeOut('slow');
    }
  });


  $('input.email-notifications-enabled').change(function () {
    const parent = $(this).parent().parent().parent();
    const notifications_toggle_checkbox = parent.find('input[data-toggle="notifications-toggle-reg"]');
    const $sms_notifications_checkbox = parent.find('input.sms-notifications-enabled');

    if (this.checked) {
      if (!notifications_toggle_checkbox.is(':checked')) {
        notifications_toggle_checkbox.prop('checked', true);
      }
    } else {
      if (notifications_toggle_checkbox.is(':checked') && !$sms_notifications_checkbox.is(':checked')) {
        notifications_toggle_checkbox.prop('checked', false);
      }
    }
  });

  $('input.sms-notifications-enabled').change(function () {
    const parent = $(this).parent().parent().parent().parent();
    const $notifications_toggle_checkbox = parent.find('input[data-toggle="notifications-toggle-reg"]');
    const $email_notifications_checkbox = parent.find('input.email-notifications-enabled');
    const $phone_number_field_container = parent.find('.phone_number');

    if (this.checked) {
      if (!$notifications_toggle_checkbox.is(':checked')) {
        $notifications_toggle_checkbox.prop('checked', true);
      }
      if (!$phone_number_field_container.find('input').val()) {
        const $verificationPhoneNumberField = parent.parents('form').find('input[name="phone_number_for_reg"]');
        if ($verificationPhoneNumberField) {
          $phone_number_field_container.find('input').val($verificationPhoneNumberField.val());
        }
      }
      $phone_number_field_container.fadeIn('slow');
    } else {
      $phone_number_field_container.fadeOut('slow');
      if (!$email_notifications_checkbox.is(':checked')) {
        $notifications_toggle_checkbox.prop('checked', false);
      }
    }
  });

})
